import { RouteComponentProps } from 'react-router';

import { KnmTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import { IKnmReasonChangeType } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonChangeType';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { IKnmDocumentRequest } from 'APIPackage/KnmModule/interfaces/IKnmDocumentRequest';
import { IKnmTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmTypeSelectOption';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { ROUTE_KNM, NEW_KNM_ID } from 'CorePackage/MainModule/routes/routes';
import { IKnmPlan } from 'PlanListPackage/MainModule/interfaces/IKnmPlan';

interface ICreateNewKnmFormPlan {
  userProsecutorOrganisationsSelectOptions: IUserOrganisationSelectOption[];
  plan: IKnmPlan | undefined;
  selectedReason?: IKnmReasonChangeType;
  documents?: IKnmDocumentRequest;
  knmTypes: IKnmTypeSelectOption[];
  history: RouteComponentProps['history'];
  setInitialKnmData: (initialData: IKnm | undefined) => void;
}

export const createNewKnmFromPlan = ({
  userProsecutorOrganisationsSelectOptions,
  plan,
  documents,
  selectedReason,
  knmTypes,
  history,
  setInitialKnmData,
}: ICreateNewKnmFormPlan) => {
  const isSeveralOrganizations =
    userProsecutorOrganisationsSelectOptions?.filter(item => item.id === plan?.prosecutorOrganizationErvkUuid).length >
    1;

  if (plan?.knmPlanData?.knoOrganizationErknm && plan?.id) {
    const initObject = {
      knmErknm: {
        knoOrganization: {
          dictId: plan?.knmPlanData?.knoOrganizationErknm?.dictId as DictionaryUUIDsEnum,
          dictVersionId: plan?.knmPlanData?.knoOrganizationErknm?.dictVersionId as string,
        },
        kindControl: plan.knmPlanData.supervisionTypeErknm
          ? {
              dictId: plan?.knmPlanData?.supervisionTypeErknm?.dictId as DictionaryUUIDsEnum,
              dictVersionId: plan?.knmPlanData?.supervisionTypeErknm?.dictVersionId as string,
            }
          : null,
        changePlanReason: selectedReason ? [{ reasonChangeType: selectedReason }] : null,
      },
      planId: (plan?.id as number) || null,
      planGuid: plan.guid,
      type: knmTypes?.find(item => item?.value === KnmTypeCodesEnum.PP) || null,
      prosecutorOrganization: {
        id: plan?.prosecutorOrganizationErvkUuid,
        code: null,
        name: plan?.prosecName,
        address: null,
        contacts: null,
        federalDistrictId: null,
        regionId: null,
        parentId: null,
        enabled: null,
        ervkUuid: plan?.prosecutorOrganizationErvkUuid,
        ervkVersionUuid: plan?.prosecutorOrganizationErvkVersionUuid,
      },
      version: plan?.knmPlanData?.version,

      documents: documents ? [documents] : null,
      isSeveralOrganizations,
    } as IKnm;

    if (plan?.knmPlanData?.supervisionTypeErknm?.dictId && initObject.knmErknm) {
      initObject.knmErknm.kindControl = {
        dictId: plan?.knmPlanData?.supervisionTypeErknm?.dictId as DictionaryUUIDsEnum,
        dictVersionId: plan?.knmPlanData?.supervisionTypeErknm?.dictVersionId as string,
      };
    }

    setInitialKnmData(initObject);
  }
  history.push(ROUTE_KNM(NEW_KNM_ID, `backUrl=${encodeURI(window.location.pathname)}`));
};
